module.exports = __webpack_public_path__ + "static/media/palma-2.cd59fcd0.webp";